module.exports = __webpack_public_path__ + "img/20190619163629569.2e919b5a.png";